export const UIBlockedButton = () => {
  // No tracking because this will quickly be replaced by purchase-motions-lib
  // We don't want to render anything for blocked purchase motions
  // https://git.hubteam.com/HubSpot/growth-ebx-planning/issues/1518
  return null;
};